__turbopack_context__.v({
  "Ad": "w4pnnW_Ad",
  "DesktopAd": "w4pnnW_DesktopAd",
  "MobileAd": "w4pnnW_MobileAd",
});
